import { Grid, makeStyles } from "@material-ui/core";
import { PageLoading } from "components/UI/Page";
import { useEffect, useState } from "react";

const useStyles = makeStyles({
  loading: { position: "relative", left: "40%" },
  frame: {
    zIndex: 999,
    border: 0,
    overflow: "hidden",
    margin: "0 auto",
    "& .kpimetric .valueLabel": {
      fontWeight: 700,
    },
  },
});

const urlDefault =
  "https://lookerstudio.google.com/embed/reporting/2f121d80-5ecb-420d-9abc-b6c0546cdda7/page/p_rsndvg1nrc";

interface IContractLookerChartProps {
  title: string;
  parameters: {
    total: number;
    measuredTotal: number;
    toBeMeasuredTotal: number;
    measuredPercentual: number;
    toBeMeasuredPercentual: number;
  };
}

const ContractLookerChart = ({
  title,
  parameters,
}: IContractLookerChartProps) => {
  const classes = useStyles();
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setUrl(createUrl());

    function createUrl(): string {
      return urlDefault + "?" + getParams();
    }

    function getParams() {
      const data = {
        "ds24.valor_total": parameters.total || 0,
        "ds24.valor_medido": parameters.measuredTotal || 0,
        "ds24.saldo_a_medir": parameters.toBeMeasuredTotal || 0,
        "ds24.percentual_medido": parameters.measuredPercentual || 0,
        "ds24.percentual_a_medir": parameters.toBeMeasuredPercentual || 0,
      };

      return `params=${encodeURI(JSON.stringify(data))}`;
    }
  }, [parameters]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ flexGrow: 1, minHeight: 320 }}
    >
      {loading && <PageLoading className={classes.loading} />}
      <iframe
        title={title}
        className={classes.frame}
        src={url}
        frameBorder="0"
        height={320}
        width={535}
        allowFullScreen
        scrolling="no"
        onLoad={() => setLoading(false)}
      ></iframe>
    </Grid>
  );
};

export default ContractLookerChart;
